(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
